import React from "react";
import { Select } from "antd";

const { Option } = Select;


const SelectDropDown = ({ setValue, size, groups, placeholder }) => {
  return (
    <Select size={size} defaultValue={groups[0]} placeholder={placeholder} style={{ width: 180 }} onChange={ setValue }>
      {groups && groups.map((group, index) => <Option key={index} value={group.toLowerCase()}>{group}</Option>)}
    </Select>
  );
};

export default SelectDropDown;
